<template>
    <div v-if="leads">
        <v-toolbar flat color="light-blue" dark>
            <v-toolbar-title>Leads</v-toolbar-title>
        </v-toolbar>
        <v-container fluid>
            <v-card>
                <v-card-title>
                    <v-checkbox
                            v-model="completed"
                            label="Is completed"
                            class="mr-2"
                        />
                    <v-checkbox
                            v-model="hasName"
                            label="Has name"
                            class="mr-2"
                        />
                    <v-checkbox
                            v-model="hasEmail"
                            label="Has email"
                            class="mr-2"
                        />
                    <v-spacer/>
                    <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                        :loading="this.$apollo.queries.leads.loading"
                        :headers="headers"
                        :items="leads.data"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        :search="search"
                        :page.sync="page"
                        :items-per-page.sync="pageCount"
                        :server-items-length="leads.paginatorInfo.lastPage * pageCount"
                >

                    <template v-slot:item.id="{ item }">
                        <v-btn
                            small
                            :to="{name: 'lead-view', params:{id: item.id}}"
                        >
                            LD-{{ item.id }}
                        </v-btn>

                    </template>

                    <template v-slot:item.leadSource="{ item }">
                        <v-chip
                                :color="getSourceColor(item)"
                                dark
                        >{{ item.leadSource }}</v-chip>

                    </template>

                    <template v-slot:item.createdAt="{ item }">
                        {{ item.createdAt | formatDate}}
                    </template>

                    <template v-slot:item.completedAt="{ item }">
                        <v-chip
                                color="green"
                                dark
                                v-if="item.completedAt"
                        >
                        {{ item.completedAt | formatDate}}
                        </v-chip>
                        <v-chip
                                color="red"
                                dark
                                v-else
                        >
                            Not submitted
                        </v-chip>
                    </template>

                    <template v-slot:item.zohoId="{ item }">
                        <v-btn
                            v-if="item.zohoId"
                            :href="createZohoLink(item.zohoId)"
                            target="_blank"
                            small
                        >View in Zoho

                        </v-btn>
                        <template
                                v-else
                        >
                            Not in Zoho
                        </template>
                    </template>

                </v-data-table>
            </v-card>
        </v-container>
    </div>
</template>

<script>
    import LEADS_LIST from "../graphql/Leads/List.gql";
    import ZohoMixin from "../mixins/ZohoMixin";

    export default {
        mixins: [ZohoMixin],
        metaInfo: {
            title: `Leads`
        },
        apollo: {
            leads: {
                query: LEADS_LIST,
                variables() {

                    let ands = []
                    let where = {AND: ands}
                    if (this.search !== '') {
                        ands.push({column: 'COMPANY', operator: 'LIKE', value: '%' + this.search + '%'})
                    }

                    if (this.completed){
                        ands.push({column: 'COMPLETED_AT', operator: 'IS_NOT_NULL'})
                    }

                    if (this.hasName){
                        ands.push({column: 'LAST_NAME', operator: 'IS_NOT_NULL'})
                    }

                    if (this.hasEmail){
                        ands.push({column: 'EMAIL1', operator: 'IS_NOT_NULL'})
                    }

                    let sortField = 'DATE_ENTERED'
                    let sortDirection = 'DESC'


                    return {
                        first: this.pageCount,
                        page: this.page,
                        where: where,
                        orderBy: {field: sortField.toUpperCase(), order: sortDirection},
                    }
                },
                update: data => data.leads
            },
        },
        data() {
            return {
                completed: false,
                hasName: true,
                hasEmail: true,
                search: '',
                page: 1,
                pageCount: 15,
                sortBy: ['date'],
                sortDesc: [true],
                headers: [
                    {
                        text: 'ID',
                        align: 'start',
                        value: 'id',
                    },
                    {
                        text: 'Created',
                        align: 'start',
                        value: 'createdAt',
                    },
                    {
                        text: 'Type',
                        align: 'start',
                        value: 'leadSource',
                    },
                    {
                        text: 'Contact',
                        align: 'start',
                        value: 'lastName',
                    },
                    {
                        text: 'Email',
                        align: 'start',
                        value: 'email',
                    },
                    {
                        text: 'Completed',
                        align: 'start',
                        value: 'completedAt',
                    },
                    {
                        text: 'Zoho',
                        align: 'start',
                        value: 'zohoId',
                    },
                ],
                sourceColors: [
                    {source: 'Web Quote', color: 'green'},
                    {source: 'Contact Us', color: 'orange'},
                ]
            }
        },
        methods: {
            getSourceColor(lead) {
                let colorMap = this.$_.find(this.sourceColors, {source: lead.leadSource})
                if(colorMap !== undefined) {
                    return colorMap.color
                }
                return ''
            },

        },
    }
</script>
